const LeftSmallArrow = () => {
  return (
    <svg width="8" height="12" viewBox="0 0 8 12">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M1.91 0L0.5 1.41 5.08 6 0.5 10.59 1.91 12 7.91 6z"
        transform="matrix(-1 0 0 1 8.41 0)"
      />
    </svg>
  );
};

export { LeftSmallArrow };
